import { cn } from "cy-fe/src/utils/cn";
import type { ReactElement, ReactNode } from "react";

export interface PageContainerProps {
  children: ReactNode;
  className?: string;
  "data-testid"?: string;
}

export function PageContainer({
  children,
  className,
  "data-testid": dataTestId,
}: PageContainerProps): ReactElement {
  return (
    <div
      data-testid={dataTestId}
      className={cn(
        "mx-auto max-w-[40rem] space-y-5",
        "px-5 sm:px-10",
        className,
      )}
    >
      {children}
    </div>
  );
}
